import { Formik, Form } from 'formik';
import DotLoader from "react-spinners/BeatLoader";
import { AddCompanyValidationSchema } from '../../../../utils/companyUtils';
import useCompanyForm from '../../../../hooks/useCompanyForm';
import SubscriptionDetails from '../../../../components/SubscriptionDetails';
import CompanyForm from '../../../../components/CompanyForm';
import { COMPANY_STATUS,COMPANY_TIER } from '@demandproai/shared';
import XButton from '../../../../components/common/XButton';
import PageTitle from '../../../../components/common/PageTitle';

const sectionHeaderClasses = "flex justify-between items-center w-full mr-4";

const AddCompaniesForm = ({ isSubmittingForm: toggleIsSubmittingForm, }) => {
  const {isloader, nextMonth, onSubmitAddCompany} = useCompanyForm(toggleIsSubmittingForm);
  

  return (<>
    <Formik
      initialValues={{
        companyName: '',
        companyPhonenumber: '',
        // companyemail: '',
        companyAddress: '',
        firstName: '',
        contactPhonenumber: '',
        lastName: '',
        emailAddress: '',
        domainName: '',
        databaseIp: '',
        taxId: '',
        databaseUser: '',
        databasePassword: '',
        ContractDetails: "",
        accountantname: "",
        accountantemail: [''],
        usersLimit: "",
        monthlyPrice: "",
        demandsPerMonth: "",
        status: COMPANY_STATUS.TRIAL,
        isDelayedPayment: false,
        costPerAdditionalUser: 0,
        costPerAdditionalDemand: 0,
        chargeAdditionalPlaintiffs: true,
        subscriptionRenewalDate: nextMonth,
        contractRenewalDate: "",
        tierNotes:"",
        startedOn: "",
        tier:COMPANY_TIER.SILVER,
        commission: 0,
        isAnnual: false,
        hsCompanyId:''
      }}
      enableReinitialize={true}
      validationSchema={AddCompanyValidationSchema}
      onSubmit={(values) => {
         
        onSubmitAddCompany(values);
      }}
    >
      {(formik) => (
        <Form>
          <div className="p-0!">
            <div className="row items-center">
              <div className="col-md-6">
                <PageTitle title="Company Information" />
              </div>
              <div className="col-md-6 flex justify-end">
                <XButton onClick={() => toggleIsSubmittingForm()}><i className='fa fa-arrow-left mr-2!'></i> Back to Companies</XButton>
              </div>
            </div>
            <h2>
              <div className={sectionHeaderClasses}>
                <span>Company Details</span>
              </div>
            </h2>
            <div className="row">
              <CompanyForm formik={formik}/>
              <SubscriptionDetails formik={formik}/>
            </div>
            <div className="btns text-right">
              <XButton variant="outlinePrimary" className="mr-3!" onClick={() => toggleIsSubmittingForm()}>Cancel</XButton>
              <XButton type="submit">Create</XButton>
            </div>
          </div>
        </Form>
      )}
    </Formik>
    <DotLoader
      color="var(--color-primary)"
      loading={isloader}
      size={30}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  </>

  );
};
export default AddCompaniesForm;
